// Simple localStorage TTL cache to minimise API calls
const PREFIX = "tm_cache_";

export function cacheGet(key, ttlMs) {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return null;
    const { ts, data } = JSON.parse(raw);
    if (Date.now() - ts > ttlMs) return null; // expired — keep entry for stale fallback
    return data;
  } catch {
    return null;
  }
}

// Returns cached data regardless of TTL — used as fallback when the API fails
export function cacheGetStale(key) {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return null;
    const { data } = JSON.parse(raw);
    return data;
  } catch {
    return null;
  }
}

export function cacheSet(key, data) {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify({ ts: Date.now(), data }));
  } catch {
    /* quota exceeded — ignore */
  }
}

export function cacheClear(prefix = "") {
  Object.keys(localStorage)
    .filter((k) => k.startsWith(PREFIX + prefix))
    .forEach((k) => localStorage.removeItem(k));
}
